import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-grid gfu-grid--gutter"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_add_product_to_cart = _resolveComponent("add-product-to-cart")
  const _component_reward_card = _resolveComponent("reward-card")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_product_card_list_provider = _resolveComponent("product-card-list-provider")

  return (_openBlock(), _createBlock(_component_product_card_list_provider, { products: $props.rewards }, {
    default: _withCtx(({ productList, onItemAdded, getAddProductToCartModel }) => [
      ($options.hasRewards)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList, (reward) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `reward-box-${reward.productID}`,
                class: "gfu-grid__cell gfu-1of1"
              }, [
                _createVNode(_component_reward_card, _mergeProps({
                  ref_for: true,
                  ref: "rewardCard"
                }, { ref_for: true }, reward), {
                  action: _withCtx(() => [
                    _createVNode(_component_add_product_to_cart, _mergeProps({ ref_for: true }, {...getAddProductToCartModel(reward), section: 'reward-card'}, { onItemAdded: onItemAdded }), null, 16 /* FULL_PROPS */, ["onItemAdded"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createBlock(_component_empty_state, {
            key: 1,
            class: "_bgc--white _rounded--common _bxsh--base _my-4",
            title: _ctx.Resources.ProjectHome.RewardsSectionEmptyStateHeader,
            description: _ctx.Resources.ProjectHome.RewardsSectionEmptyStateDescription
          }, null, 8 /* PROPS */, ["title", "description"]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["products"]))
}